/**
 * Adapptio Shared library.
 *
 * @package lib-shared
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { v4 as uuid_v4 } from "uuid";

export function uuid(): string {
	return uuid_v4();
}
